































import Vue from 'vue'

/* eslint-disable */ 
import { Dealer } from '../models/Dealer'
/* eslint-enable */

import ContactAndMedia from '../components/ContactAndMedia.vue'

export default Vue.extend ({
  data () {
    return {
    }    
  },
  computed: {
    currentYear() : number {
      return new Date().getFullYear()
    },
    currentDealer() : Dealer {
      return this.$store.state.dealers.currentDealer
    },
  },
  components: {
    ContactAndMedia
  }
})
